const IOS_TOP_SAFE_AREA = 'var(--native-safe-area-top, env(safe-area-inset-top, 0px))'

const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum)

export function getMobileMediaDockAnchor({ viewportWidth, viewportHeight, newButtonRect, gap }) {
    if (!newButtonRect) return null

    return {
        right: Math.round(viewportWidth - newButtonRect.left + gap),
        bottom: Math.round(viewportHeight - newButtonRect.bottom),
    }
}

export function constrainMobileMediaDockPosition({
    requestedLeft,
    requestedTop,
    dockWidth,
    dockHeight,
    viewportWidth,
    bottomBoundary,
    margin,
    topBoundary = margin,
}) {
    const maximumLeft = Math.max(margin, viewportWidth - dockWidth - margin)
    const maximumTop = Math.max(topBoundary, bottomBoundary - dockHeight - margin)

    return {
        left: Math.round(clamp(requestedLeft, margin, maximumLeft)),
        top: Math.round(clamp(requestedTop, topBoundary, maximumTop)),
    }
}

export function getExpandedMediaDockHeight({
    viewportHeight,
    dockBottom,
    isMobileViewport,
    respectTopSafeArea = false,
}) {
    const topMargin = isMobileViewport ? 12 : 16
    const height = viewportHeight - dockBottom - topMargin

    return respectTopSafeArea ? `calc(${height}px - ${IOS_TOP_SAFE_AREA})` : height
}
